export default __webpack_public_path__ + "static/media/seen.033eb2e0.svg";